import { useState } from "react";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";
import { fetchAPI } from "../components/service/Encrtyption";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { rewardMoney } from "../components/auth/redux/store";
import { useDispatch } from "react-redux";


export const parseQueryParams = (queryString) => {
  const params = new URLSearchParams(queryString);
  const queryParams = {};

  for (const [key, value] of params) {
    queryParams[key] = value;
  }

  return queryParams;
};

export const useParamarshDetails = () => {
  // debugger;
  const formData = {
    cashFreeTransactionId: 0,
    dsrId: 0,
    ecouponFarmerMapId: 0,
    moduleType: "Farmer",
    programId: 0,
    reClaim: "No",
    showView: false,
    countOfToBeClaims: 0,
    dsrProgramId: 0,
    ecouponFarmerId: 0,
    enableSprayService: false,
    isCortevaProduct: false,
    isLumivia: false,
    isProductAlreadyScaned: false,
    isSpinDone: false,
    lumiviaServReqRecordID: 0,
    multipleRewards: false,
    seadProgramId: 0,
    showClickableLink: false,
    showLuckyWinnerPopup: false,
    showRetailerIdPopup: false,
    uq_responseCode: 0,
    wheelStoppingIndex: 0,
    destinationURL: "/cashFreeReward/getCashFreeTransactionPendingRequest_V2",
  };
  const [rewardsData, setRewardsData] = useState([]);
  const [reclaimData, setReclaimData] = useState([]);
  const [cashRewardsData, setCashRewards] = useState("");
  const [reclaimRewards, setReclaimRewards] = useState([]);
  const [errroMsg, setErrorMsg] = useState("");
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const browserType = sessionStorage.getItem("browserName") || "web";

  const hide = () => {
    setErrorMsg("");
  };

  const user = useSelector((state) => state.user);
  const fetchData = async () => {
    // debugger;
    // alert("fetchData called in useParamarshDetails");
    //  const mobileNumber = user?.mobileNumber;
    const mobileNumber = sessionStorage.getItem('mbn');

    if (!mobileNumber) {
      // setErrorMsg(t("sessionExperied"));
      setTimeout(() => {
        navigate(`/${lang}/giftHistory`);
      }, 2000);
      return;
    }

    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        formData,
        {
          mobileNumber: mobileNumber,
          appLangCode: lang,
          deviceType: "web",
          browserType: browserType,
        }
      );
      // debugger;
      const jsonReposneData = JSON.parse(responseData);
      const claimList = jsonReposneData?.dsrTransactionList?.dsrClaimList;
      const reClaimList = jsonReposneData?.dsrTransactionList?.dsrReClaimList;
      const generateClaimIDs = () => {
        return claimList.map((item) => ({
          benfTransactionId: "",
          dsrProgramId: 0,
          ecouponFarmerMapId: 0,
          seadProgramId: 0,
          serverRecordId: item?.serverRecordId,
        }));
      };
      const generateReclaim = () => {
        return reClaimList.map((item) => ({
          benfTransactionId: "",
          dsrProgramId: 0,
          ecouponFarmerMapId: 0,
          seadProgramId: 0,
          serverRecordId: item?.serverRecordId,
        }));
      };
      const generatecashRewards = () => {
        const totalCashRewards = claimList?.reduce(
          (total, item) => total + parseFloat(item?.cashRewards),
          0
        );
        return totalCashRewards?.toFixed(2);
        // alert(totalCashRewards?.toFixed(2) + " totalCashRewards in generatecashRewards");
      };

      const generateReclaimcashRewards = () => {
        const totalCashRewards = reClaimList?.reduce(
          (total, item) => total + parseFloat(item?.amount),
          0
        );
        return totalCashRewards?.toFixed(2);
      };
      const cashRewardsSum = generatecashRewards();
      const reclaimRewards = generateReclaimcashRewards();
      setRewardsData(generateClaimIDs());
      setReclaimData(generateReclaim());
      setCashRewards(cashRewardsSum);
      setReclaimRewards(reclaimRewards);
      dispatch(rewardMoney(cashRewardsData));
      console.log("setRewardsData" + rewardsData);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [null, null, null, null, null];
    }
  };

  return [fetchData, rewardsData, reclaimRewards, reclaimData, cashRewardsData];
};


export const initGA = (trackingID) => {
  ReactGA.initialize(trackingID);
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
};